"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateGoalParamsSchema = exports.DeleteGoalTemplateParamsSchema = exports.UpdateGoalParamsSchema = exports.UpdateGoalTemplateSchema = exports.UpdateGoalTemplateParamsSchema = exports.CreateGoalTemplateSchema = exports.CreateGoalTemplateParamsSchema = exports.GetGoalsTemplateParamsSchema = exports.GetGoalParamsSchema = exports.GetGoalsParamsSchema = exports.GoalCollectionSchema = exports.PaginationParamsSchema = exports.GoalTemplateCollectionSchema = exports.PaginationSchema = exports.GetDetailedGoalTemplateParamsSchema = exports.GetDetailedGoalTemplateSchema = exports.GoalSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../helpers/schemas");
const campaign_1 = require("../campaign");
const GoalTypeEnum = zod_1.z.enum(['transaction', 'event', 'pageview', 'screenview']);
const OperatorEnum = zod_1.z.enum(['contains', 'ignoringParameters', 'exact', 'regexp']);
const PriorityEnum = zod_1.z.enum(['main', 'secondary', 'rollback']);
const MetricsEnum = zod_1.z.enum(['uniqueConversions', 'value', 'averageValue']);
const AccountEnvironmentSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    environment: zod_1.z.string().optional(),
});
const GoalTemplateSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: GoalTypeEnum,
    account_environment: AccountEnvironmentSchema.optional(),
    label: zod_1.z.string(),
    context: zod_1.z.string().nullable().optional(),
    operator: OperatorEnum.optional(),
    value: zod_1.z.string().optional(),
});
exports.GoalSchema = zod_1.z.object({
    id: zod_1.z.string(),
    created_at: zod_1.z.string(),
    formatted_created_at: schemas_1.ApiDateTimeSchema,
    type: GoalTypeEnum,
    priority: PriorityEnum,
    metrics: zod_1.z.array(MetricsEnum),
    order: zod_1.z.number(),
    name: zod_1.z.string().nullable(),
    goal_template: GoalTemplateSchema.nullable(),
});
const CampaignStateSchema = zod_1.z.object({
    state: campaign_1.FeatureExpCampaignStateSchema,
});
const CampaignSchema = zod_1.z.object({
    current_state: CampaignStateSchema,
    status: campaign_1.FeatureExpStatusSchema,
    id: zod_1.z.string(),
    name: zod_1.z.string(),
});
const GoalTemplateGoalSchema = zod_1.z.object({
    campaign: CampaignSchema,
});
exports.GetDetailedGoalTemplateSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: GoalTypeEnum,
    account_environment: AccountEnvironmentSchema,
    label: zod_1.z.string(),
    goals: zod_1.z.array(GoalTemplateGoalSchema),
    context: zod_1.z.string().nullable().optional(),
    operator: OperatorEnum.optional(),
    value: zod_1.z.string().optional(),
});
exports.GetDetailedGoalTemplateParamsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    goalTemplateId: zod_1.z.string(),
    accountEnvId: zod_1.z.string(),
});
const GoalTemplateConditionSchema = GoalTemplateSchema.extend({
    operator: OperatorEnum.optional(),
    value: zod_1.z.string().optional(),
});
exports.PaginationSchema = zod_1.z.object({
    current_items_count: zod_1.z.number(),
    current_page: zod_1.z.number(),
    total_count: zod_1.z.number(),
    items_per_page: zod_1.z.number(),
    last_page: zod_1.z.number(),
});
exports.GoalTemplateCollectionSchema = exports.PaginationSchema.extend({
    items: zod_1.z.array(GoalTemplateConditionSchema),
});
exports.PaginationParamsSchema = zod_1.z.object({
    _max_per_page: zod_1.z.number().optional(),
    _page: zod_1.z.number().optional(),
});
exports.GoalCollectionSchema = exports.PaginationSchema.extend({
    items: zod_1.z.array(exports.GoalSchema),
});
exports.GetGoalsParamsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    campaignId: zod_1.z.string(),
    params: exports.PaginationParamsSchema.optional(),
});
exports.GetGoalParamsSchema = exports.GetGoalsParamsSchema.extend({
    goalId: zod_1.z.string(),
});
exports.GetGoalsTemplateParamsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    accountEnvId: zod_1.z.string(),
    params: exports.PaginationParamsSchema.optional(),
});
exports.CreateGoalTemplateParamsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    accountEnvId: zod_1.z.string(),
    type: GoalTypeEnum,
    label: zod_1.z.string(),
    operator: OperatorEnum.optional(),
    value: zod_1.z.string().optional(),
    context: zod_1.z.string().nullable().optional(),
});
exports.CreateGoalTemplateSchema = exports.CreateGoalTemplateParamsSchema.extend({
    id: zod_1.z.string(),
});
exports.UpdateGoalTemplateParamsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    accountEnvId: zod_1.z.string(),
    goalTemplateId: zod_1.z.string(),
    label: zod_1.z.string(),
    context: zod_1.z.string().nullable().optional(),
    operator: OperatorEnum.optional(),
    value: zod_1.z.string().optional(),
});
exports.UpdateGoalTemplateSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    accountEnvId: zod_1.z.string(),
    goalTemplateId: zod_1.z.string(),
    label: zod_1.z.string(),
    context: zod_1.z.string().nullable().optional(),
    operator: OperatorEnum.optional(),
    value: zod_1.z.string().optional(),
});
exports.UpdateGoalParamsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    campaignId: zod_1.z.string(),
    goalId: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    order: zod_1.z.number().optional(),
    type: GoalTypeEnum.optional(),
    priority: PriorityEnum.optional(),
    metrics: zod_1.z.array(MetricsEnum).optional(),
    goal_template_id: zod_1.z.string().optional(),
});
exports.DeleteGoalTemplateParamsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    accountEnvId: zod_1.z.string(),
    goalTemplateId: zod_1.z.string(),
});
exports.CreateGoalParamsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    campaignId: zod_1.z.string(),
    name: zod_1.z.string(),
    type: GoalTypeEnum,
    priority: PriorityEnum,
    metrics: zod_1.z.array(MetricsEnum),
    goal_template_id: zod_1.z.string(),
    order: zod_1.z.number(),
});
//# sourceMappingURL=schemas.js.map